module.exports = __webpack_public_path__ + "static/media/ALEGIONELLA-off.72c0acf0.svg";